export default "__VITE_ASSET__Dhmf9gq1__"